import { ResortLink } from "../resort-button";
import { Eyebrow, MaskReveal, Reveal } from "../reveal";

const steps = [
  {
    n: "01",
    title: "Explore",
    copy: "Use the resort map to understand the property layout.",
  },
  {
    n: "02",
    title: "Request",
    copy: "Tell Auburn RV Resort about your dates, RV and site preferences.",
  },
  {
    n: "03",
    title: "Confirm",
    copy: "The resort team reviews availability and contacts you directly.",
  },
];

export function SiteRequestProcess() {
  return (
    <section aria-labelledby="map-process-heading" className="bg-background py-14 md:py-18">
      <div className="shell">
        <Reveal>
          <Eyebrow>How It Works</Eyebrow>
        </Reveal>
        <h2 id="map-process-heading" className="display-lg mt-6 max-w-[20ch]">
          <MaskReveal>See the Map. Request Availability.</MaskReveal>
          <MaskReveal delay={0.08}>We&apos;ll Handle the Rest.</MaskReveal>
        </h2>

        <ol className="mt-8 grid gap-8 md:grid-cols-3">
          {steps.map((step, i) => (
            <li key={step.n}>
              <Reveal delay={i * 0.06}>
                <h3 className="font-display mt-3 text-2xl tracking-tight">{step.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-muted-foreground">{step.copy}</p>
              </Reveal>
            </li>
          ))}
        </ol>

        <Reveal delay={0.12}>
          <div className="mt-8 border border-border bg-secondary/40 p-6 md:p-8">
            <p className="eyebrow text-primary">Site assignments shown on the map are not live inventory.</p>
            <p className="mt-3 max-w-3xl text-sm leading-relaxed text-muted-foreground">
              Auburn RV Resort confirms actual availability and site assignments manually.
            </p>
            <ResortLink variant="solid" href="/reservations/" className="mt-6 w-full sm:w-auto">
              Request Availability
            </ResortLink>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
